import angular from 'angular';

import CommandModule from './tabs/commands/commands.module';

import AssetDetailsDashboardComponent, { AssetDetailsDashboardController } from './asset-details-dashboard.component';
import AssetDataComponent from './tabs/data/asset-data.component';
import SeriesDataChartComponent from './tabs/data/chart/series-chart.component';
import SeriesDataTableComponent from './tabs/data/series-table/series-table.component';
import AssetDetailsSectionComponent from './tabs/details/asset-details.component';
import AssetLocationComponent from './tabs/location/asset-location.component';
import AssetAlertsComponent from './tabs/alerts/asset-alerts.component';
import AssetMaintenanceComponent from './tabs/maintenance/asset-maintenance.component';
import AssetDeviceDiagnosticsComponent from './tabs/device-diagnostics/device-diagnostics.component';
import AssetImageEditModalController from './tabs/details/images/asset-image-edit.modal.controller';
import AssetImageUploadController from './tabs/details/images/asset-image-upload.modal.controller';
import SetAssetLocationController from './tabs/location/pin-location-modal/set-asset-location.modal.controller';

const assetDetailsDashboardModule = angular.module('asset.details.dashbord', ['ui.bootstrap', CommandModule]);

assetDetailsDashboardModule
  .controller('AssetDetailsDashboardController', AssetDetailsDashboardController)
  .controller('AssetImageEditController', AssetImageEditModalController)
  .controller('AssetImageUploadController', AssetImageUploadController)
  .controller('SetAssetLocationController', SetAssetLocationController)
  .component('assetDetailsDashboard', AssetDetailsDashboardComponent)
  .component('assetDataOverview', AssetDataComponent)
  .component('seriesChart', SeriesDataChartComponent)
  .component('seriesTable', SeriesDataTableComponent)
  .component('assetDetailsSection', AssetDetailsSectionComponent)
  .component('assetLocation', AssetLocationComponent)
  .component('assetAlerts', AssetAlertsComponent)
  .component('assetMaintenance', AssetMaintenanceComponent)
  .component('assetDeviceDiagnostics', AssetDeviceDiagnosticsComponent);

export default assetDetailsDashboardModule.name;
